import type { ReactNode } from 'react';
import { cn } from '@shared/lib';

/**
 * Карточка «Тренировка на сегодня» новой главной (макет владельца 2026-10-22): сверху — что делать сейчас (план дня,
 * продолжение или старт), снизу через черту — строка серии. Одна рамка вместо двух блоков: серия и тренировка —
 * одно действие «зайти и позаниматься». Высота — по содержимому, не по соседней плашке: рядом с выросшей «На сегодня»
 * карточка тянулась с 213 до 360 px, и текст с кнопкой висели посередине (владелец 2026-10-26, «очень много воздуха»).
 */
export function TodayCard({ children, strip, footer, phone }: { children: ReactNode; strip?: ReactNode; footer?: ReactNode; phone: boolean }) {
  return (
    <section className="overflow-hidden rounded-card border border-solid border-line bg-card">
      <div>{children}</div>
      {strip && <div className={cn('border-t border-solid border-line', phone ? 'px-4 py-3' : 'px-8 py-4')}>{strip}</div>}
      {/* Поле «Своё слово в карточки» (главная, 2026-11-03: «должно быть заметнее для тех, кто пришёл за карточками»). */}
      {footer && <div className={cn('border-t border-solid border-line bg-[#1a1a1d]', phone ? 'px-4 py-3.5' : 'px-8 py-4')}>{footer}</div>}
    </section>
  );
}
